module.exports = __webpack_public_path__ + "fonts/Arnhem-NormalItalic.4ee3d83.woff2";